import { IRegistrationSection } from '../../../interfaces/scheduler_interfaces';
import { Section } from '../../sections/builders/section_builder';
import * as _4 from 'lodash4';

export class RegistrationSection extends Section implements IRegistrationSection {
  static build(regSection: RegistrationSection) {
    return new RegistrationSection(regSection);
  }
  is_selected: boolean;

  constructor(regSection: RegistrationSection) {
    super(regSection);
    _4.merge(this, regSection);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/registration_section_builder.ts